import Link from 'next/link';

export const data = [
    {
        question: 'What forms of payment do you accept?',
        answer: <p>We accept all major credit cards such as Visa, Mastercard, and Discover, as well as other popular payment methods like Apple Pay, Cash App, Google Pay, and more.</p>,
    },
    {
        question: 'On what date will I be charged for my subscription?',
        answer: (
            <>
                <p>
                    Your membership subscription automatically renews every month from your initial date of sign up. For example: If you signed up on March 15th, your next billing date would be April
                    15th.
                </p>
                <p>
                    Note payments are automatic, should you wish to avoid future charges make sure to cancel at least 72 hours prior to your billing date to ensure no funds will be applied to your
                    account. Automatic payments can begin to process up to 48 hours before your billing date so it is imperative the subscription is canceled within that 72-hour window.
                </p>
                <p>No refunds will be issued once payment has been applied to your account.</p>
                <p>
                    <a href="https://support.bpmsupreme.com/hc/en-us/articles/115002394687-I-m-not-satisfied-with-my-membership-Can-I-get-a-refund">
                        https://support.bpmsupreme.com/hc/en-us/articles/115002394687-I-m-not-satisfied-with-my-membership-Can-I-get-a-refund
                    </a>
                </p>
            </>
        ),
    },
    {
        question: 'How do promotions work?',
        answer: (
            <p>
                Each promotion will vary. Please note promotions do not roll over onto future billing unless explicitly stated. The promotion will only be applied to the first billing cycle. Note any
                upgrades to the Premium membership are subject to an upgrade fee. If you have questions about a specific promo code please email{' '}
                <a href="mailto:info@bpmsupreme.com?subject=Contact">info@bpmsupreme.com</a> for more details on your code or review the Terms of Use.
            </p>
        ),
    },
    {
        question: 'How do I update my payment method and/or subscription?',
        answer: (
            <p>
                To update your payment information please click on the Account icon in the top right and go to Manage Account &gt; <Link href="./payment">Payment Method</Link>. If you would like to
                update your subscription please go to Manage Account &gt; Available Plans or click the ‘Change Plan’ button on the <Link href="./overview">Manage Account</Link> page.
            </p>
        ),
    },
    {
        question: 'How do I cancel my subscription?',
        answer: (
            <p>
                Click on the Account icon in the top right and go to Manage Account. Once there click the ‘Cancel’ link next to the ‘Change Plan’ button or go to the Payment Method section and click
                ‘Cancel Subscription’ then proceed with the next steps. You will receive an email confirmation once your subscription has been canceled.
            </p>
        ),
    },
];
